<template>
    <div class="col-lg-12 d-flex flex-column"> 
        <div class="col-12 pb-5 mb-4" v-if="pageloader">
            <img src="../../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
        </div>
        <div class="pb-5" v-if="!pageloader">
            <div class="col-12 card pt-4 introvideocard" v-if="companyBenefitsList.length > 0">
                <div v-for="(benefit, index) in companyBenefitsList" :key="index" class="col-11 ml-3 mb-2">
                    <div class="border-0 mb-3  borderadius12">
                        <div class="d-flex">
                            <div>
                                <img src="../../assets/Profile_placehlder.svg" class="img-fluid" alt="benefitlogo">
                            </div>
                            <div class="d-flex flex-column ml-3 mr-auto">
                                <span class="fontsize20 black proximanova">{{benefit.type}}</span>
                                <span class="fontsize14 black60 proximanova">{{benefit.benifits}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 card mb-4 introvideocard borderradius10" v-else>
                <div class="row no-gutters p-2" >
                <div class="col p-5 text-center">
                    <img src="../../assets/no_video.svg" class="img-md-fluid img-sm-fluid no-video pl-5 pr-5 pb-4" alt="novideo">
                    <div class="col d-flex justify-content-center fontsize16 black60 proximanova">No Benefits's Found</div>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import $ from 'jquery'
export default{
    data(){
        return{
            pageloader  :true,
            //details section
            companyProfileId : null,
            companyBenefitsList : []
        }
    },
    components: {
    },
    methods :{
        fetchData() {
            this.getCompanyBenefitsList()
        },
        // initial rendering company benefits data
        getCompanyBenefitsList() {
            httpuserprofile.get('/userprofile/getCompanyBenifits?companyProfileId='+this.companyProfileId)
            .then((response) => {
                this.pageloader = false;
                this.companyBenefitsList = response.data;
            }).catch((e) => {
                this.pageloader = false;
                console.log(e)
            })
        },
    },
    mounted(){
        this.companyProfileId = this.$session.get("company_profile_id")
        this.fetchData()
    }
}
</script>
<style scoped>
.introvideocard{
  padding-left: 0;
  padding-right: 0;
  border-radius: 10px;
}
.pageloader{
  width: 10%;
  margin-left: 45%;
  margin-top: 5%;
}
@media only screen and (max-width: 600px){
  .pageloader {
    width: 20%;
    margin-top: 25%;
  }
}
</style>
